import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hress1e/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hress1e/labels')
  },
  getIndex (searchParams) {
    let dteyreap = ''
    let numtime = ''
    dteyreap = (typeof searchParams.year !== 'undefined' ? searchParams.year : '')
    numtime = (typeof searchParams.numtime !== 'undefined' ? searchParams.numtime : '')
    if (isMock) return generator(mocker.index())
    return instance().get(endpoint + '/hress1e/index/' + dteyreap + '/' + numtime)
  },
  getDetail (searchParams) {
    let dataParams = {
      p_dteyreap: searchParams.p_dteyreap,
      p_numtime: searchParams.p_numtime,
      p_kpino: searchParams.p_kpino
    }
    if (isMock) return generator(mocker.detail())
    const params = dataParams.p_dteyreap + '/' + dataParams.p_numtime + '/' + dataParams.p_kpino
    return instance().get(endpoint + '/hress1e/detail/' + params)
  },
  getDropdowns () {
    if (isMock) return generator(mocker.dropdowns())
    return instance().get(endpoint + '/hress1e/dropdowns')
  },
  postDetail2Save ({ indexSelected, dataRowsHasFlg }) {
    var params = []
    for (var i = 0; i < dataRowsHasFlg.length; i++) {
      var dataRow = dataRowsHasFlg[i]
      params.push({
        'dteapkpi': dataRow.dteapkpi,
        'actbedon': dataRow.actbedon,
        'mtrvalue': dataRow.mtrvalue,
        'mtrvalnet': dataRow.mtrvalnet
      })
    }
    var saveParams = {
      'codempid': indexSelected.codempid,
      'dteyreap': indexSelected.dteyreap,
      'numtime': indexSelected.numtime,
      'kpino': indexSelected.kpino,
      'status': indexSelected.status,
      'param_json': JSON.stringify(dataRowsHasFlg)
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hress1e/detail1Table2Save', saveParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hress1e/index.js